import { ApiResponse, postRequest } from "@/data/apiClient";

export interface EmailSendRequest {
  subject: string;
  body: string;
  recipients?: string[];
}

export interface EmailSendResponse {
  errorMessage?: string;
}

export const emailSend = async (
  params: EmailSendRequest
): Promise<ApiResponse<EmailSendResponse[]>> =>
  postRequest("/emailAllUsers", params);
